import { render } from "./ChefView.vue?vue&type=template&id=08c11e85&scoped=true"
import script from "./ChefView.vue?vue&type=script&lang=js"
export * from "./ChefView.vue?vue&type=script&lang=js"

import "./ChefView.vue?vue&type=style&index=0&id=08c11e85&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/freefi_meal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c11e85"]])

export default __exports__